import { computed as s, openBlock as o, createElementBlock as i, normalizeClass as l, createBlock as d, createCommentVNode as u, createTextVNode as c, createVNode as m, withCtx as p, renderSlot as f } from "vue";
import g from "./design-system.es58.js";
import h from "./design-system.es106.js";
/* empty css                    */
/* empty css                    */
import w from "./design-system.es128.js";
const v = /* @__PURE__ */ Object.assign({
  name: "DsStatus"
}, {
  __name: "Status",
  props: {
    /**
     * Controls level of emphasis in the styling.
     * Must be 'low', 'medium', or 'high'
     */
    emphasis: {
      type: String,
      default: "low",
      options: ["low", "medium", "high"],
      validator: (e) => ["low", "medium", "high"].includes(e)
    },
    /**
     * Controls the color of the status label.
     * Must be 'default', 'good', 'warning', or 'error'
     */
    type: {
      type: String,
      default: "default",
      options: ["default", "good", "warning", "error"],
      validator: (e) => ["default", "good", "warning", "error"].includes(e)
    },
    /**
     * Controls whether the status label has a leading icon.
     */
    leadingIcon: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = s(() => {
      if (t.emphasis !== "medium" && !t.leadingIcon)
        return "";
      switch (t.type) {
        case "good":
          return "check-circle";
        case "warning":
          return "alert-triangle";
        case "error":
          return "slash";
        default:
          return "info-circle";
      }
    });
    return (n, r) => (o(), i("div", {
      class: l(["ds-status", `ds-status--${e.type || "default"}-${e.emphasis || "low"}`])
    }, [
      a.value ? (o(), d(g, {
        key: 0,
        name: a.value,
        size: "xs"
      }, null, 8, ["name"])) : u("", !0),
      r[0] || (r[0] = c()),
      m(h, { variant: "headline-5" }, {
        default: p(() => [
          f(n.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), N = /* @__PURE__ */ w(v, [["__scopeId", "data-v-e58aa11e"]]);
export {
  N as default
};
//# sourceMappingURL=design-system.es96.js.map
